export class OptionsAdminSearch {
    public plantNumber: number;
    public pageRequested: number;
    public optionsPerPage: number;
    public productLineCode: string;
    public categoryId: number;
    public searchString: string;
    public showUntouched: boolean;

    constructor() {
        this.plantNumber = null;
        this.pageRequested = null;
        this.optionsPerPage = null;
        this.productLineCode = null;
        this.categoryId = null;
        this.searchString = null;
        this.showUntouched = false;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/model/options-admin-search.ts